/**
 * Format a nutrition value for display — rounds to 1 decimal place max.
 * Examples:
 *   13       → 13
 *   0.5      → 0.5
 *   16.66666 → 16.7
 *   3.65     → 3.7
 *   null/NaN → 0
 *
 * Use this anywhere a raw macro/calorie value is rendered to the user.
 * Do NOT use on internal state — keep state precise; round only at display.
 */
export const formatMacro = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 10) / 10;
};
